import React, { useRef, useEffect } from 'react'
import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Carousel } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { useSelector } from 'react-redux';

const TaskImageSlider = ({ showModal, closeModal, imgArr, kidChangeTo, getLangTranslation }) => {
  // console.log("img arr =>>", imgArr)
  const modalRef = useRef();
  const carouselRef = useRef(null);
  const { kidList } = useSelector(({ dashboard }) => dashboard);
  const parentID = kidList?.find((element) => element?.ID === kidChangeTo)?.parentID;

  useEffect(() => {
    if (showModal) {
      const modal = new Modal(modalRef.current, {
        backdrop: 'static',
        keyboard: false,
      });
      modal.show();

      if (carouselRef.current) {
        new Carousel(carouselRef.current);
      }
    }
  }, [showModal]);

  return (
    <>
      <div className="modal fade" tabIndex="-1" ref={modalRef}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0">
              <h6 className="modal-title text-blue-900">{getLangTranslation("PHOTO", "Photo")}</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
            </div>
            {
              imgArr?.length > 0 && (
                <div className="modal-body">
                  <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel" ref={carouselRef}>
                    <div className="carousel-inner">
                      {
                        imgArr?.map((item, index) => {
                          return (
                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                              <img src={`${process.env
                                .REACT_APP_AMAZON_S3_IMAGE_URL_PREFIX_NEW}/${btoa(parentID)}/Tasks/${item}}`} className="d-block w-100" alt="..." />
                            </div>
                            // <div className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                            //   <img src={taskSliderImg} className="d-block w-100" alt="..." />
                            // </div>
                          )
                        })
                      }

                      {/* <div className="carousel-item">
                    <img src={taskSliderImg} className="d-block w-100" alt="..." />
                  </div>
                  <div className="carousel-item">
                    <img src={taskSliderImg} className="d-block w-100" alt="..." />
                  </div> */}
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                      <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">{getLangTranslation("PREVIOUS", "Previous")}</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                      <span className="carousel-control-next-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">{getLangTranslation("NEXT", "Next")}</span>
                    </button>
                  </div>
                </div>
              )
            }

            {
              imgArr?.length === 0 && (
                <div className='w-100 text-center py-3'>
                  {getLangTranslation('ATTACHMENT_NOT_AVAILABLE', 'Attachment not available')}
                </div>
              )
            }

          </div>
        </div>
      </div>
    </>
  )
}

export default TaskImageSlider